<template>
    <v-card class="fill-height">
        <v-card-title primary-title>
            <h3 class="headline">Physiothérapeutes</h3>
            <v-spacer></v-spacer>
            <v-btn right color="primary" :to="{ name: 'physio.add' }">
                <v-icon>add</v-icon> Créer un physiothérapeute
            </v-btn>


        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
            <v-layout align-center justify-end row>
                <v-flex xs6>
                    <v-text-field v-model="search" append-icon="search" label="Recherche" single-line
                                  hide-details></v-text-field>
                </v-flex>
            </v-layout>
        </v-card-text>

        <v-data-table
            class="mx-4"
            :headers="headers"
            :items="physios"
            :search="search"
            :pagination.sync="paginator">
            <template v-slot:items="props">
                <router-link tag="tr" :to="{name: 'physio.edit', params: { id: props.item.id } }">
                    <td>{{ props.item.name }}</td>
                    <td>{{ props.item.phone }}</td>
                    <td>{{ props.item.email }}</td>
                    <td>{{ props.item.address }}</td>
                    <td>{{ props.item.postcode }}</td>
                    <td>{{ props.item.city }}</td>
                    <td>{{ props.item.country }}</td>
                </router-link>
            </template>
            <template v-slot:no-results>
                <v-alert :value="true" color="error" icon="warning">
                    Aucun résultat pour "{{ search }}".
                </v-alert>
            </template>
        </v-data-table>
    </v-card>
</template>

<script>
    import {mapActions, mapState} from 'vuex'

    export default {
        name: "PhysioList",
        computed: mapState({
            physios: state => state.physios.all
        }),
        data() {
            return {
                has_error: false,
                search: '',
                headers: [
                    {text: 'Nom', align: 'left', value: 'name'},
                    {text: 'Adresse', align: 'left', value: 'address'},
                    {text: 'Tel', align: 'left', value: 'phone'},
                    {text: 'Email', align: 'left', value: 'email'},
                    {text: 'Code postal', align: 'left', value: 'postcode'},
                    {text: 'Ville', align: 'left', value: 'city'},
                    {text: 'Pays', align: 'left', value: 'country'},
                ],
                paginatorText: "Résultats par page",
                paginator: {
                    rowsPerPage: 25,
                    sortBy: 'name',
                    //descending:true
                }
            }
        },

        mounted() {
            this.getAllPhysios()
        },
        methods: {
            ...mapActions('physios', [
                'getAllPhysios'
            ])
        }
    }
</script>
